export default __webpack_public_path__ + "a2c582678cdd3f23090294ebd9ce1ae9.gif";